export default __webpack_public_path__ + "fonts/inter-latin-700-normal.65a568f2a9065247687a.woff2";